module.exports = __webpack_public_path__ + "img/stepTarget.83c9bb30.png";